export const ExlcusiveCountryCode = {
  CY: 'CY',
  EG: 'EG',
  GH: 'GH',
  GR: 'GR',
  HU: 'HU',
  IN: 'IN',
  IL: 'IL',
  LU: 'LU',
  NG: 'NG',
  PS: 'PS',
  PL: 'PL',
  UA: 'UA',
}

export const TranslatedCountryCode = {
  DE: 'DE',
  ES: 'ES',
}

export const exlcusive = {
  [ExlcusiveCountryCode.CY]: {
    name: 'Κύπρο',
    flag: '🇨🇾',
    link: '/exclusive-distributor-cyprus',
    title: 'Visit our official Cyprus 🇨🇾 website',
    alt: 'Αποκλειστικός διανομέας 1Home στην Κύπρο',
    btn_redirect: 'Visit 1Home for Cyprus',
    btn_close: 'Continue to the global site & get redirected on checkout',
  },
  [ExlcusiveCountryCode.EG]: {
    name: 'Egypt',
    flag: '🇪🇬',
    link: '/exclusive-distributor-egypt',
    title: 'Visit our official Egypt 🇪🇬 website',
    alt: 'Exclusive 1Home distributor in Egypt',
    btn_redirect: 'Visit 1Home for Egypt',
    btn_close: 'Continue to the global site & get redirected on checkout',
  },
  [ExlcusiveCountryCode.GH]: {
    name: 'Ghana',
    flag: '🇨🇬',
    link: '/exclusive-distributor-ghana',
    title: 'Visit our official Ghana 🇨🇬 website',
    alt: 'Exclusive 1Home distributor in Ghana',
    btn_redirect: 'Visit 1Home for Ghana',
    btn_close: 'Continue to the global site & get redirected on checkout',
  },
  [ExlcusiveCountryCode.GR]: {
    name: 'Ελλάδα',
    flag: '🇬🇷',
    link: '/exclusive-distributor-greece',
    title: 'Visit our official Greece 🇬🇷 website',
    alt: 'Αποκλειστικός διανομέας 1Home στην Ελλάδα',
    btn_redirect: 'Visit 1Home for Greece',
    btn_close: 'Continue to the global site & get redirected on checkout',
  },
  [ExlcusiveCountryCode.HU]: {
    name: 'Magyarország',
    flag: '🇭🇺',
    link: '/exclusive-distributor-hungary',
    title: 'Visit our official Hungary 🇭🇺 website',
    alt: 'Exkluzív 1Home forgalmazó Magyarországon',
    btn_redirect: 'Visit 1Home for Hungary',
    btn_close: 'Continue to the global site & get redirected on checkout',
  },
  [ExlcusiveCountryCode.IN]: {
    name: 'India',
    flag: '🇮🇳',
    link: '/exclusive-distributor-india',
    title: 'Visit our official India 🇮🇳 website',
    alt: 'Exclusive 1Home distributor in India',
    btn_redirect: 'Visit 1Home for India',
    btn_close: 'Continue to the global site & get redirected on checkout',
  },
  [ExlcusiveCountryCode.IL]: {
    name: 'Israel',
    flag: '🇮🇱',
    link: '/exclusive-distributor-israel',
    title: 'Visit our official Israel 🇮🇱 website',
    alt: 'Exclusive 1Home distributor in Israel',
    btn_redirect: 'Visit 1Home for Israel',
    btn_close: 'Continue to the global site & get redirected on checkout',
  },
  [ExlcusiveCountryCode.LU]: {
    name: 'Luxembourg',
    flag: '🇱🇺',
    link: '/exclusive-distributor-luxembourg',
    title: 'Visit our official Luxembourg 🇱🇺 website',
    alt: 'Distributeur exclusif de 1Home à Luxembourg',
    btn_redirect: 'Visit 1Home for Luxembourg',
    btn_close: 'Continue to the global site & get redirected on checkout',
  },
  [ExlcusiveCountryCode.NG]: {
    name: 'Nigeria',
    flag: '🇳🇬',
    link: '/exclusive-distributor-nigeria',
    title: 'Visit our official Nigeria 🇳🇬 website',
    alt: 'Exclusive 1Home distributor in Nigeria',
    btn_redirect: 'Visit 1Home for Nigeria',
    btn_close: 'Continue to the global site & get redirected on checkout',
  },
  [ExlcusiveCountryCode.PS]: {
    name: 'Palestine',
    flag: '🇵🇸',
    link: '/exclusive-distributor-palestine',
    title: 'Visit our official Palestine 🇵🇸 website',
    alt: 'الموزع الحصري لمنتجات 1HOME في فلسطين',
    btn_redirect: 'Visit 1Home for Palestine',
    btn_close: 'Continue to the global site & get redirected on checkout',
  },
  [ExlcusiveCountryCode.PL]: {
    name: 'Poland',
    flag: '🇵🇱',
    link: '/exclusive-distributor-poland',
    title: 'Visit our official Poland 🇵🇱 website',
    alt: 'Wyłączny dystrybutor 1Home w Polsce',
    btn_redirect: 'Visit 1Home for Poland',
    btn_close: 'Continue to the global site & get redirected on checkout',
  },
  [ExlcusiveCountryCode.UA]: {
    name: 'Українa',
    flag: '🇺🇦',
    link: '/exclusive-distributor-ukraine',
    title: 'Visit our official Ukraine 🇺🇦 website',
    alt: 'Ексклюзивний дистрибютор 1Home в Україні',
    btn_redirect: 'Visit 1Home for Ukraine',
    btn_close: 'Continue to the global site & get redirected on checkout',
  },
}

export const translated = {
  [TranslatedCountryCode.DE]: {
    name: 'Deutschland',
    flag: '🇩🇪',
    link: '/de',
    title: 'Besuchen Sie unsere offizielle Website für 🇩🇪 Deutschland',
    alt: 'Exklusiver 1Home Vertriebspartner in Deutschland',
    btn_redirect: 'Besuchen Sie 1Home für Deutschland',
    btn_close: 'Weiter zur globalen Website & Weiterleitung beim Checkout',
  },
  [TranslatedCountryCode.ES]: {
    name: 'España',
    flag: '🇪🇸',
    link: '/es',
    title: 'Visita nuestra web oficial para 🇪🇸 España',
    alt: 'Distribuidor exclusivo de 1Home en España',
    btn_redirect: 'Visita 1Home para España',
    btn_close: 'Continúe al sitio global y sea redirigido al pagar',
  },
}

export const exlcusiveContact = [
  {
    id: [ExlcusiveCountryCode.CY],
    name: 'Cyprus',
    company_name: 'GABS Systems Ltd.',
    address: '65 Atlantos, Lakatamia, Nicosia 2326, Cyprus',
    phone: '+357 99308456',
    email: 'sales@gabs.systems',
    website: 'https://www.gabs.systems',
    link: 'mailto:sales@gabs.systems',
  },
  {
    id: [ExlcusiveCountryCode.EG],
    name: 'Egypt',
    company_name: 'Smart Now',
    address: '',
    phone: '+20 1101117646',
    email: 'info@smartnow-egypt.com',
    website: 'https://smartnow-egypt.com',
    link: 'mailto:info@smartnow-egypt.com',
  },
  {
    id: [ExlcusiveCountryCode.GH],
    name: 'Ghana',
    company_name: 'Powerecng',
    address: '',
    phone: '+234 7030610630',
    email: 'sales@powerecng.com',
    website: 'http://www.powerecng.com',
    link: 'mailto:sales@powerecng.com',
  },
  {
    id: [ExlcusiveCountryCode.GR],
    name: 'Greece',
    company_name: 'Kafkas',
    address: '',
    phone: '+30 2163003333',
    email: 'customercare@kafkas.gr',
    website: 'https://5342.short.gy/kafkas',
    link: 'mailto:customercare@kafkas.gr',
  },
  {
    id: [ExlcusiveCountryCode.HU],
    name: 'Hungary',
    company_name: 'ZoszkoWorks Kft',
    address: '3240 Parád, Kossuth út 56., Hungary',
    phone: '+36 305895330',
    email: 'info@zoszkoworks.com',
    website: 'https://zoszkoworks.com',
    link: 'mailto:info@zoszkoworks.com',
  },
  {
    id: [ExlcusiveCountryCode.IN],
    name: 'India',
    company_name: 'Morion Automation Pvt. Ltd.',
    address: 'Morion Automation Pvt. Ltd., 4th Floor, Fortune Monarch, Road No 36, Jubliee Hills, Madhapur, Hyderabad',
    phone: '+91 9000600125',
    email: 'info@morion.in',
    website: 'https://www.morion.in',
    link: 'mailto:info@morion.in',
  },
  {
    id: [ExlcusiveCountryCode.IL],
    name: 'Israel',
    company_name: 'Inspera Smart Home',
    address: '',
    phone: '+972 0723953007',
    email: 'office@inspera.co.il',
    website: 'https://www.inspera.co.il',
    link: 'mailto:office@inspera.co.il',
  },
  {
    id: [ExlcusiveCountryCode.LU],
    name: 'Luxembourg',
    company_name: 'Smartcube SARL',
    address: '6, rue du Fort Bourbon, L-1249 Luxembourg',
    phone: '+352 621257775',
    email: 'team@smartcube.lu',
    website: 'https://www.smartcube.lu',
    link: 'mailto:team@smartcube.lu',
  },
  {
    id: [ExlcusiveCountryCode.NG],
    name: 'Nigeria',
    company_name: 'Powerecng',
    address: '',
    phone: '+234 7030610630',
    email: 'sales@powerecng.com',
    website: 'http://www.powerecng.com',
    link: 'mailto:sales@powerecng.com',
  },
  {
    id: [ExlcusiveCountryCode.PS],
    name: 'Palestine',
    company_name: 'Alfanar',
    address: '',
    phone: '+972 568522031',
    email: 'yasmeen@alfanar.ps',
    website: 'http://alfanar.ps',
    link: 'mailto:yasmeen@alfanar.ps',
  },
  {
    id: [ExlcusiveCountryCode.PL],
    name: 'Poland',
    company_name: 'DYSTRON',
    address: 'Hetmańska 26, 60-252 Poznań, Poljska',
    phone: '+48 515545946',
    email: 'zamowienia@dystron.pl',
    website: 'https://dystron.pl',
    link: 'mailto:zamowienia@dystron.p',
  },
  {
    id: [ExlcusiveCountryCode.UA],
    name: 'Ukraine',
    company_name: 'Smart Tech',
    address: '28A Panasa Myrnoho Str. Kyiv, Ukraine',
    phone: '+380 445457706',
    email: 'sales@smarttech.com.ua',
    website: 'https://smarttech.com.ua',
    link: 'mailto:sales@smarttech.com.ua',
  },
]
